module.exports = __webpack_public_path__ + "static/media/logo-alcaldia-blanco.9c82d90a.png";